import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
    status: boolean
}

const StatusChip = ({ status }: Props) => {
    const { t } = useTranslation('global')

    return <Chip
        style={{
            backgroundColor: status ? '#36B37E29' : '#FF563029',
            color: status ? '#1B806A' : '#B71D18',
            borderRadius: '5px'
        }}
        label={status ? t("clearanceMoney_page.Confirm") : t("clearanceMoney_page.Not Confirm")}
    />
}
export default StatusChip;